import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {
    groups: [],
  },
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .get("user", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getBankHolidays(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getBankHolidays", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    deleteBankHoliday(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteBankHoliday/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    /********* Roles */
    /*********** */
    fetchRoles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("roles", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    fetchPermissions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("permissions", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    addRole(ctx, role) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("roles/store", role)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    updateRole(payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`roles/${payload.role}`, payload.permissions)
          .then((response) => {
            resolve(response);
            //    showToast("success");
          })
          .catch((error) => reject(error));
      });
    },

    // TASKS

    getAllTasks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("getAllTasks", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getTaskById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getTaskById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateTask(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateTask/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteTask(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`deleteTask/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    saveTask(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveTask", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    // DEPARTMENT

    getAllDepartments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("getAllDepartments", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getDepartmentById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getDepartmentById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateDepartment(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateDepartment/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteDepartment(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`deleteDepartment/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    saveDepartment(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveDepartment", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //SITES

    getAllSites(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("getAllSites", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

        takeSiteOffline(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("takeOffline", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    restoreSiteOnline(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("restoreOffline", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getOfflinePeriods(ctx, siteId) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getOfflinePeriods/${siteId}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    

    getRoles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("getRoles", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getSiteById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getSiteById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateSite(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateSite/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteSite(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`deleteSite/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    saveSite(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveSite", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    takeSiteOffline(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("takeOffline", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    restoreSiteOnline(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("restoreOffline", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getOfflinePeriods(ctx, siteId) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getOfflinePeriods/${siteId}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllTimelineActions(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getAllTimelineActions", { params })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    sendTestEmails(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("sendApprovalMailsTest")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllPermissionListReqChange(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getAllPermissionListReqChange")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchQuestionnaires(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getQuestionnaires")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    copyQuestionnaire(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("copyQuestionnaire", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateQuestionnaireColor(ctx, questionnaire) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateQuestionnaireColor/${questionnaire.id}`, questionnaire)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    createQuestionnaire(ctx, questionnaireName) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("createQuestionnaire", questionnaireName)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateReview(ctx, questionnaire) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateQuestionnaire/${questionnaire.id}`, questionnaire)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    addNewQuestionItem(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveQuestion", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    addNewGroupItem(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveGroup", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteGroup(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("deleteGroup", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchGroups(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("listGroup", { id: id })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    fetchReview(ctx, id) {
      return new Promise((resolve, reject) => {
        resolve({
          status: 200,
          message: "Quality Review fetched successfully",
        });

        // axiosIns
        //   .get(`review/${id}`)
        //   .then((response) => {
        //     resolve(response);
        //   })
        //   .catch((error) => reject(error));
      });
    },

    deleteQuestion(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteQuestion/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    editQuestion(ctx, question) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`editQuestion/${question.id}`, question)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchQuestionnaireDetail(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getQuestionnaireDetail/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateQuestionResultTable(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("updateQuestionResultTable", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    controlQuestionResultTable(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("controlQuestionAndResultInTable", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    addQuestionResultTable(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("addQuestionResultTable", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    deleteQuestionResultTable(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("deleteQuestionResultTable", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    copyNewQuestionnaireForAdd(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("copyNewQuestionnaireForAdd", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    copyNewQuestionnaireForUpdate(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("copyNewQuestionnaireForUpdate", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    copyNewQuestionnaireForDelete(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("copyNewQuestionnaireForDelete", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    controlGroupResultTable(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("controlGroupResultInTable", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateGroupResultTable(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("updateGroupResultTable", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateQuestionOrderForGroup(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("reorderQuestions", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    copyNewQuestionnaireForGroupUpdate(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("copyNewQuestionnaireForGroupUpdate", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    editGroup(ctx, group) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`editReviewGroupName/${group.id}`, group)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteQuestionnaire(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteQuestionnaire/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchsummaryList(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`summaryList/${id}`)
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    summaryUpdate(ctx, gl) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`summaryUpdate/${gl.id}`, gl)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    // New summary management functions
    fetchSummaryDropdownList(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("summaryDropdownList")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchSummaryById(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`summary/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    copyNewQuestionnaireForTaskChange(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("copyNewQuestionnaireForTaskChange", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateSummaryById(ctx, { id, data }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`summary/${id}`, data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

        copyNewQuestionnaireForTaskChange(ctx, obj) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("copyNewQuestionnaireForTaskChange", obj)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
  },
};
